import Input from '@material-ui/core/Input';
import { currencyToSymbol } from 'utils/currencies';

const textFilterMethod = (filter, row) => {
  const filterId = filter.pivotId || filter.id;
  return String(row[filterId] ?? '')
    .toLowerCase()
    .includes(String(filter.value ?? '').toLowerCase());
};

const columnConfig = ({
  t,
  currency,
  canEdit,
  priceInputClassName,
  onValueChange,
}) => [
  {
    accessor: 'mealTypeName',
    Header: (
      <span>
        {t('$*shop.defaultPriceMeals.mealType')}
        <span className="DataGrid-arrow" />
      </span>
    ),
    filterable: true,
    filterMethod: textFilterMethod,
    sortable: true,
    Cell: ({ original }) => (
      <span>
        {original.mealTypeName}
        {original.hasChanged ? ` ${t('common.shared.modified')}` : ''}
      </span>
    ),
  },
  {
    accessor: 'calories',
    Header: (
      <span>
        {t('$*shop.defaultPriceMeals.size')}
        <span className="DataGrid-arrow" />
      </span>
    ),
    filterable: true,
    filterMethod: textFilterMethod,
    sortable: true,
    Cell: ({ original }) =>
      original.calories ? `${original.calories} kcal` : '',
  },
  {
    accessor: 'value',
    Header: (
      <span>
        {t('$*shop.defaultPriceMeals.defaultPrice', {
          replace: { currencySymbol: currencyToSymbol(currency) },
        })}
        <span className="DataGrid-arrow" />
      </span>
    ),
    filterable: false,
    sortable: false,
    Cell: ({ original }) => (
      <Input
        inputProps={{
          className: priceInputClassName,
          disabled: !canEdit,
          type: 'number',
          value: original.value ?? '',
          onChange: e => onValueChange(original['@id'], e.target.value),
        }}
      />
    ),
  },
];

export default columnConfig;
